export default "__VITE_ASSET__0b060e2b__"